import { createSlice } from '@reduxjs/toolkit';

const promptsSlice = createSlice({
    name: 'prompts',
    initialState: {
        categories: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        promptList: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        reactions: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        userReaction: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        dataModals: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 1,
            total: 0,
            totalPages: 1,
        },
        promptDetail: { loading: false, error: null },
        createCategory: { loading: false, error: null },
        updateCategory: { loading: false, error: null },
        toggleCategoryStatus: { loading: false, error: null },
        createPrompt: { loading: false, error: null },
        updatePrompt: { loading: false, error: null },
        createPromptDataModal: {loading: false, error: null},
        updatePromptDataModal: {loading: false, error: null},
        togglePromptStatus: { loading: false, error: null },
        reactToPrompt: { loading: false, error: null },
        importPrompts: {
                    loading: false,
                    error: null,
                },
    },
    reducers: {
        // Categories
         fetchCategoriesStart: (state, action) => {
            state.categories.loading = true;
            state.categories.error = null;
            if (action.payload.page === 1) {
                state.categories.data = [];
            }
        },
        fetchCategoriesSuccess: (state, action) => {
            state.categories = { ...action.payload, loading: false };
        },
        fetchCategoriesFail: (state, action) => {
            state.categories.loading = false;
            state.categories.error = action.payload;
        },
        createCategoryStart: (state) => {
            state.createCategory.loading = true;
            state.createCategory.error = null;
        },
        createCategorySuccess: (state) => {
            state.createCategory.loading = false;
        },
        createCategoryFail: (state, action) => {
            state.createCategory.loading = false;
            state.createCategory.error = action.payload;
        },
        updateCategoryStart: (state) => {
            state.updateCategory.loading = true;
            state.updateCategory.error = null;
        },
        updateCategorySuccess: (state) => {
            state.updateCategory.loading = false;
        },
        updateCategoryFail: (state, action) => {
            state.updateCategory.loading = false;
            state.updateCategory.error = action.payload;
        },
        toggleCategoryStatusStart: (state) => {
            state.toggleCategoryStatus.loading = true;
            state.toggleCategoryStatus.error = null;
        },
        toggleCategoryStatusSuccess: (state) => {
            state.toggleCategoryStatus.loading = false;
        },
        toggleCategoryStatusFail: (state, action) => {
            state.toggleCategoryStatus.loading = false;
            state.toggleCategoryStatus.error = action.payload;
        },

        // Prompts
        fetchPromptsStart: (state, action) => {
            state.promptList.loading = true;
            state.promptList.error = null;
            if (action.payload.page === 1) {
                state.promptList.data = [];
            }
        },
        fetchPromptsSuccess: (state, action) => {
            state.promptList = { ...action.payload, loading: false };
        },
        fetchPromptsFail: (state, action) => {
            state.promptList.loading = false;
            state.promptList.error = action.payload;
        },
        fetchPromptDetailStart: (state) => {
            state.promptDetail.loading = true;
            state.promptDetail.error = null;
        },
        fetchPromptDetailSuccess: (state, action) => {
            state.promptDetail = { ...action.payload, loading: false, error: null };
        },
        fetchPromptDetailFail: (state, action) => {
            state.promptDetail.loading = false;
            state.promptDetail.error = action.payload;
        },
        createPromptStart: (state) => {
            state.createPrompt.loading = true;
            state.createPrompt.error = null;
        },
        createPromptSuccess: (state) => {
            state.createPrompt.loading = false;
        },
        createPromptFail: (state, action) => {
            state.createPrompt.loading = false;
            state.createPrompt.error = action.payload;
        },
        updatePromptStart: (state) => {
            state.updatePrompt.loading = true;
            state.updatePrompt.error = null;
        },
        updatePromptSuccess: (state) => {
            state.updatePrompt.loading = false;
        },
        updatePromptFail: (state, action) => {
            state.updatePrompt.loading = false;
            state.updatePrompt.error = action.payload;
        },
        fetchPromptDataModalsStart: (state, action) => {
            state.dataModals.loading = true;
            state.dataModals.error = null;
            if (action.payload.page === 1) {
                state.dataModals.data = [];
            }
        },
        fetchPromptDataModalsSuccess: (state, action) => {
            state.dataModals = { ...action.payload, loading: false };
        },
        fetchPromptDataModalsFail: (state, action) => {
            state.dataModals.loading = false;
            state.dataModals.error = action.payload;
        },
        createPromptDataModalStart: (state) => {
            state.createPromptDataModal.loading = true;
            state.createPromptDataModal.error = null;
        },
        createPromptDataModalSuccess: (state) => {
            state.createPromptDataModal.loading = false;
        },
        createPromptDataModalFail: (state, action) => {
            state.createPromptDataModal.loading = false;
            state.createPromptDataModal.error = action.payload;
        },
        updatePromptDataModalStart: (state) => {
            state.updatePromptDataModal.loading = true;
            state.updatePromptDataModal.error = null;
        },
        updatePromptDataModalSuccess: (state) => {
            state.updatePromptDataModal.loading = false;
        },
        updatePromptDataModalFail: (state, action) => {
            state.updatePromptDataModal.loading = false;
            state.updatePromptDataModal.error = action.payload;
        },

        fetchReactionsStart: (state) => {
            state.reactions.loading = true;
            state.reactions.error = null;
        },
        fetchReactionsSuccess: (state, action) => {
            state.reactions.loading = false;
            state.reactions.data = action.payload;
        },
        fetchReactionsFail: (state, action) => {
            state.reactions.loading = false;
            state.reactions.error = action.payload;
        },
        fetchUserReactionStart: (state) => {
            state.userReaction.loading = true;
            state.userReaction.error = null;
        },
        fetchUserReactionSuccess: (state, action) => {
            state.userReaction.loading = false;
            state.userReaction.data = action.payload;
        },
        fetchUserReactionFail: (state, action) => {
            state.userReaction.loading = false;
            state.userReaction.error = action.payload;
        },
        importPromptsStart: (state) => {
            state.importPrompts.loading = true;
            state.importPrompts.error = null;
        },
        importPromptsSuccess: (state) => {
            state.importPrompts.loading = false;
        },
        importPromptsFail: (state, action) => {
            state.importPrompts.loading = false;
            state.importPrompts.error = action.payload;
        }
    },
});

export const {
    fetchCategoriesStart,
    fetchCategoriesSuccess,
    fetchCategoriesFail,
    createCategoryStart,
    createCategorySuccess,
    createCategoryFail,
    updateCategoryStart,
    updateCategorySuccess,
    updateCategoryFail,
    toggleCategoryStatusStart,
    toggleCategoryStatusSuccess,
    toggleCategoryStatusFail,
    fetchPromptsStart,
    fetchPromptsSuccess,
    fetchPromptsFail,
    fetchPromptDetailStart,
    fetchPromptDetailSuccess,
    fetchPromptDetailFail,
    createPromptStart,
    createPromptSuccess,
    createPromptFail,
    updatePromptStart,
    updatePromptSuccess,
    updatePromptFail,
    fetchPromptDataModalsStart,
    fetchPromptDataModalsSuccess,
    fetchPromptDataModalsFail,
    createPromptDataModalStart,
    createPromptDataModalSuccess,
    createPromptDataModalFail,
    updatePromptDataModalStart,
    updatePromptDataModalSuccess,
    updatePromptDataModalFail,
    togglePromptStatusStart,
    togglePromptStatusSuccess,
    togglePromptStatusFail,
    reactToPromptStart,
    reactToPromptSuccess,
    reactToPromptFail,
    fetchReactionsStart,
    fetchReactionsSuccess,
    fetchReactionsFail,
    fetchUserReactionStart,
    fetchUserReactionSuccess,
    fetchUserReactionFail,
    importPromptsStart,
    importPromptsSuccess,
    importPromptsFail,
} = promptsSlice.actions;

export default promptsSlice.reducer;